import React from 'react';
import ChecklistModalContainer  from './checklist-modal.container';
import { Col, Row, Button, FormGroup, Card, CardBody, CardTitle, CardText, Label } from 'reactstrap';
import './checklist.style.css';
import IntlMessage from '../../../../../../helpers/intlMessage';

const ChecklistPage = (props) =>
    (
        <div >
            {
                props.modalChecklist  &&
                <ChecklistModalContainer
                    isOpen={props.modalChecklist}
                    perguntas={props.respostas}
                    toggle={props.toggleModalChecklist}
                    style={{overflowY:'auto', height: '100%'}}
                    readonly={props.readonly}
                />
            }
            <p className="title"><IntlMessage id = "dashboards.examDetail.questionnaireHistory"/></p>
            {
                !props.recebimentoFinalizado && <Row>
                    <Col sm="auto" className="paddingRight-zero">
                        <FormGroup>
                            <Button
                                className='paddingLeft-zero'
                                color="link"
                                onClick={props.responderQuestionario}
                            >
                                <span><IntlMessage id = "dashboards.examDetail.replyAgain"/></span>
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
            }

            <div style={{ height: `${props.altura - 104}px`, overflowY: 'scroll', overflowX: 'hidden' }}>
                {
                    props.historicos.map((item) => {
                        return <Row key={item.id}>
                            <Col>
                                <Card onClick={() => props.visualizarHistorico(item.id)}>
                                    <CardBody>
                                        <Row>
                                            <Col>
                                                <CardTitle>
                                                    {item.dataHistorico}
                                                    {
                                                        item.impeditiva && <div style={{ float: 'left', display: 'contents'}}>
                                                            <Label data-toggle="tooltip" title="">
                                                                <div className="exame-aberto"><IntlMessage id = "dashboards.examDetail.impeditive"/></div>
                                                            </Label>
                                                        </div>
                                                    }
                                                </CardTitle>
                                                <CardText>
                                                    <strong><IntlMessage id = "dashboards.examDetail.user"/></strong>{item.nomeUsuario}
                                                </CardText>
                                                <CardText>
                                                    <strong><IntlMessage id = "dashboards.examDetail.quiz"/></strong>{item.descricaoQuestionario}
                                                </CardText>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    })
                }
            </div>
        </div>
    )

export default ChecklistPage;


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/material/tabs/checklist/checklist.page.js